import { getErrorMessage } from 'application/util/error.util';

import './subscribe.style.sass';
import template from './subscribe.tpl.pug';

class SubscribeController {
    /* @ngInject */
    constructor($state, $window, planService, configuration, notificationService) {
        this.$state = $state;
        this.$window = $window;
        this.planService = planService;
        this.configuration = configuration;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.loading = true;

        this.planService.getAllUpgrade().then((plans) => {
            this.plans = plans;
        }, (result) => {
            this.notificationService.showError(getErrorMessage(result, `It looks like we were unable to retrieve the pricing plans. Please check back later.`), null, true);
        }).finally(() => {
            this.loading = false;
        });
    }

    select(plan, subscription) {
        if (subscription) {
            return this.$state.go('authorized.payment', {
                plan: plan ? plan.id : null,
                subscription: subscription ? subscription.id : null
            });
        }

        return this.$window.open(`mailto:${this.configuration.salesEmail}`, '_self');
    }

    goBack() {
        this.$state.go('authorized.calendar');
    }
}

export default {
    selector: 'dbASubscribe',
    template: template(),
    controller: SubscribeController
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/subscribe/subscribe.cmpt.js